/**
 * Detect when TPRM is embedded in GRC (iframe) or should not hard-redirect to /login.
 * Centralizes logic so axios, router, and auth stay consistent.
 */

export function isCrossOriginFramed() {
  if (typeof window === 'undefined') return false
  try {
    return window.self !== window.top
  } catch {
    // Browsers throw when cross-origin parent blocks access — still framed
    return true
  }
}

const SHELL_KEY = 'tprm_grc_shell'

export function markTprmGrcShell() {
  try {
    sessionStorage.setItem(SHELL_KEY, '1')
  } catch {
    /* private mode / quota */
  }
}

export function isTprmEmbeddedShell() {
  if (typeof window === 'undefined') return false
  if (isCrossOriginFramed()) return true
  try {
    if (sessionStorage.getItem(SHELL_KEY) === '1') return true
  } catch {
    /* ignore */
  }
  try {
    const u = new URL(window.location.href)
    if (u.searchParams.get('embedded') === '1' || u.searchParams.get('shell') === 'grc') {
      return true
    }
  } catch {
    /* ignore */
  }
  return false
}

/** Dev / ops: set VITE_TPRM_NO_LOGIN_REDIRECT=true to open TPRM directly with GRC-issued tokens */
export function suppressStandaloneLoginRedirectEnv() {
  try {
    return String(import.meta.env.VITE_TPRM_NO_LOGIN_REDIRECT || '').toLowerCase() === 'true'
  } catch {
    return false
  }
}

export function shouldAvoidLoginRedirect() {
  return isTprmEmbeddedShell() || suppressStandaloneLoginRedirectEnv()
}

export function requestAuthFromParent() {
  if (typeof window === 'undefined') return
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type: 'TPRM_AUTH_REQUEST' }, '*')
  }
}
